import { render, staticRenderFns } from "./HotelType.vue?vue&type=template&id=1547da12&"
import script from "./HotelType.vue?vue&type=script&lang=js&"
export * from "./HotelType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports